/**
 * 工具函数
 */
const self = {
  isIE: (ver) => {
    let b = document.createElement('b');
    b.innerHTML = '<!--[if IE ' + ver + ']><i></i><![endif]-->';
    return b.getElementsByTagName('i').length === 1;
  },
  BrowserType: () => {
    let userAgent = navigator.userAgent; // 取得浏览器的userAgent字符串
    let isOpera = userAgent.indexOf('Opera') > -1; // 判断是否Opera浏览器
    // var isIE = userAgent.indexOf("compatible") > -1 && userAgent.indexOf("MSIE") > -1 && !isOpera; //判断是否IE浏览器
    let isIE = window.ActiveXObject || 'ActiveXObject' in window;
    // var isEdge = userAgent.indexOf("Windows NT 6.1; Trident/7.0;") > -1 && !isIE; //判断是否IE的Edge浏览器
    let isEdge = userAgent.indexOf('Edge') > -1; // 判断是否IE的Edge浏览器
    let isFF = userAgent.indexOf('Firefox') > -1; // 判断是否Firefox浏览器
    let isSafari = userAgent.indexOf('Safari') > -1 && userAgent.indexOf('Chrome') == -1; // 判断是否Safari浏览器
    let isChrome = userAgent.indexOf('Chrome') > -1 && userAgent.indexOf('Safari') > -1 && !isEdge; // 判断Chrome浏览器

    if (isIE) {
      let reIE = new RegExp('MSIE (\\d+\\.\\d+);');
      reIE.test(userAgent);
      let fIEVersion = parseFloat(RegExp.$1);
      if (userAgent.indexOf('MSIE 6.0') != -1) {
        return 'IE6';
      } else if (fIEVersion == 7) {
        return 'IE7';
      } else if (fIEVersion == 8) {
        return 'IE8';
      } else if (fIEVersion == 9) {
        return 'IE9';
      } else if (fIEVersion == 10) {
        return 'IE10';
      } else if (userAgent.toLowerCase().match(/rv:([\d.]+)\) like gecko/)) {
        return 'IE11';
      }
      return '0';
    }
    if (isFF) {
      return 'FF';
    }
    if (isOpera) {
      return 'Opera';
    }
    if (isSafari) {
      return 'Safari';
    }
    if (isChrome) {
      return 'Chrome';
    }
    if (isEdge) {
      return 'Edge';
    }
  },
  /**
   * 农历
   */
  lunar: () => {
    let CalendarData = new Array(100);
    let madd = new Array(12);
    let tgString = '甲乙丙丁戊己庚辛壬癸';
    let dzString = '子丑寅卯辰巳午未申酉戌亥';
    let numString = '一二三四五六七八九十';
    let monString = '正二三四五六七八九十冬腊';
    let sx = '鼠牛虎兔龙蛇马羊猴鸡狗猪';
    let cYear; let cMonth; let cDay; let
      TheDate;
    CalendarData = new Array(0xA4B, 0x5164B, 0x6A5, 0x6D4, 0x415B5, 0x2B6, 0x957, 0x2092F, 0x497, 0x60C96, 0xD4A, 0xEA5, 0x50DA9, 0x5AD, 0x2B6, 0x3126E, 0x92E, 0x7192D, 0xC95, 0xD4A, 0x61B4A, 0xB55, 0x56A, 0x4155B, 0x25D, 0x92D, 0x2192B, 0xA95, 0x71695, 0x6CA, 0xB55, 0x50AB5, 0x4DA, 0xA5B, 0x30A57, 0x52B, 0x8152A, 0xE95, 0x6AA, 0x615AA, 0xAB5, 0x4B6, 0x414AE, 0xA57, 0x526, 0x31D26, 0xD95, 0x70B55, 0x56A, 0x96D, 0x5095D, 0x4AD, 0xA4D, 0x41A4D, 0xD25, 0x81AA5, 0xB54, 0xB6A, 0x612DA, 0x95B, 0x49B, 0x41497, 0xA4B, 0xA164B, 0x6A5, 0x6D4, 0x615B4, 0xAB6, 0x957, 0x5092F, 0x497, 0x64B, 0x30D4A, 0xEA5, 0x80D65, 0x5AC, 0xAB6, 0x5126D, 0x92E, 0xC96, 0x41A95, 0xD4A, 0xDA5, 0x20B55, 0x56A, 0x7155B, 0x25D, 0x92D, 0x5192B, 0xA95, 0xB4A, 0x416AA, 0xAD5, 0x90AB5, 0x4BA, 0xA5B, 0x60A57, 0x52B, 0xA93, 0x40E95);
    madd[0] = 0;
    madd[1] = 31;
    madd[2] = 59;
    madd[3] = 90;
    madd[4] = 120;
    madd[5] = 151;
    madd[6] = 181;
    madd[7] = 212;
    madd[8] = 243;
    madd[9] = 273;
    madd[10] = 304;
    madd[11] = 334;

    function GetBit (m, n) {
      return (m >> n) & 1;
    }

    function e2c () {
      TheDate = (arguments.length != 3) ? new Date() : new Date(arguments[0], arguments[1], arguments[2]);
      let total; let m; let n; let
        k;
      let isEnd = false;
      let tmp = TheDate.getYear();
      if (tmp < 1900) {
        tmp += 1900;
      }
      total = (tmp - 1921) * 365 + Math.floor((tmp - 1921) / 4) + madd[TheDate.getMonth()] + TheDate.getDate() - 38;

      if (TheDate.getYear() % 4 == 0 && TheDate.getMonth() > 1) {
        total++;
      }
      for (m = 0; ; m++) {
        k = (CalendarData[m] < 0xfff) ? 11 : 12;
        for (n = k; n >= 0; n--) {
          if (total <= 29 + GetBit(CalendarData[m], n)) {
            isEnd = true;
            break;
          }
          total = total - 29 - GetBit(CalendarData[m], n);
        }
        if (isEnd) { break; }
      }
      cYear = 1921 + m;
      cMonth = k - n + 1;
      cDay = total;
      if (k == 12) {
        if (cMonth == Math.floor(CalendarData[m] / 0x10000) + 1) {
          cMonth = 1 - cMonth;
        }
        if (cMonth > Math.floor(CalendarData[m] / 0x10000) + 1) {
          cMonth--;
        }
      }
    }

    function GetcDateString () {
      let tmp = '';
      tmp += tgString.charAt((cYear - 4) % 10);
      tmp += dzString.charAt((cYear - 4) % 12);
      tmp += '(';
      tmp += sx.charAt((cYear - 4) % 12);
      tmp += ')年 ';
      if (cMonth < 1) {
        tmp += '(闰)';
        tmp += monString.charAt(-cMonth - 1);
      } else {
        tmp += monString.charAt(cMonth - 1);
      }
      tmp += '月';
      tmp += (cDay < 11) ? '初' : ((cDay < 20) ? '十' : ((cDay < 30) ? '廿' : '三十'));
      if (cDay % 10 != 0 || cDay == 10) {
        tmp += numString.charAt((cDay - 1) % 10);
      }
      return tmp;
    }

    function GetLunarDay (solarYear, solarMonth, solarDay) {
      // solarYear = solarYear<1900?(1900+solarYear):solarYear;
      if (solarYear < 1921 || solarYear > 2020) {
        return '';
      }
      solarMonth = (parseInt(solarMonth) > 0) ? (solarMonth - 1) : 11;
      e2c(solarYear, solarMonth, solarDay);
      return GetcDateString();
    }

    let D = new Date();
    let yy = D.getFullYear();
    let mm = D.getMonth() + 1;
    let dd = D.getDate();
    let ww = D.getDay();
    let ss = parseInt(D.getTime() / 1000);
    return GetLunarDay(yy, mm, dd);
  },
  formatDate: (nS, flag = false) => {
    if (!nS) {
      return '';
    }
    const date = new Date(parseInt(nS));
    const _y = date.getFullYear();
    const _m = Appendzero(date.getMonth() + 1);
    const _d = Appendzero(date.getDate());
    const _h = Appendzero(date.getHours());
    const $m = Appendzero(date.getMinutes());
    if (flag) {
      return _y + '-' + _m + '-' + _d + '  ' + _h + ':' + $m;
    }
    return _y + '-' + _m + '-' + _d;
  },

  /**
   * 为没有text属性的树赋值text属性
   * @param {*} data:Array
   */
  walkNoTextTree: (data) => {
    if (Array.isArray(data)) {
      if (data[0] && data[0].text) {
        return;
      }
      data.forEach((item) => {
        item.text = item.name;
        self.walkNoTextTree(item.children);
      });
      return data;
    }
  },
  /**
   * 默认选中tree第一个叶子节点
   */
  selectTreeDefault: (data) => {
    if (data instanceof Array) {
      if (data[0].children && data[0].children.length > 0) {
        self.selectTreeDefault(data[0].children);
      } else {
        data[0].selected = true;
      }
    } else {
      data.selected = true;
    }
  }
};

function Appendzero (obj) {
  if (obj < 10) { return '0' + '' + obj; }
  return obj;
}

function getCSS (curEle, attr) {
  // curele:对象; attr：要获取的的属性
  if (window.getComputedStyle) {
    // ie9以上浏览器支持
    return window.getComputedStyle(curEle, null).getPropertyValue(attr);
  }
  return curEle.currentStyle[attr];
}

function overflowhidden (text, rows, str) {
  let lineHeight = getCSS(text, 'line-height'); // 获取到line-height样式设置的值 必须要有
  let at = rows * parseInt(lineHeight, 10); // 计算包含文本的div应该有的高度
  let tempstr = str; // 获取到所有文本
  text.innerHTML = tempstr; // 将所有文本写入html中
  let len = tempstr.length;
  let i = 0;
  if (text.offsetHeight <= at) {
    // 如果所有文本在写入html后文本没有溢出，那不需要做溢出处理
    /* text.innerHTML = tempstr; */
  } else {
    // 否则 一个一个字符添加写入 不断判断写入后是否溢出
    let temp = '';
    text.innerHTML = temp;
    while (text.offsetHeight <= at) {
      temp = tempstr.substring(0, i + 1);
      i++;
      text.innerHTML = temp;
    }
    let slen = temp.length;
    tempstr = temp.substring(0, slen - 1);
    len = tempstr.length;
    text.innerHTML = tempstr.substring(0, len - 3) + '...'; // 替换string后面三个字符
    text.height = at + 'px'; // 修改文本高度 为了让CSS样式overflow：hidden生效
  }
}

self.overflowhidden = overflowhidden;
module.exports = self;
